import request from '@/utils/request-v2'
import serialize from '@/utils/serialize'

export function getStudents(data) {
  return request({
    url: `/teacher/classes/${data.classId}/students` + serialize(data),
    method: 'get'
  })
}

export function addStudent(data) {
  return request({
    url: `/teacher/classes/${data.classId}/students`,
    method: 'post',
    data
  })
}

export function reviewJoinClassRequest(data) {
  return request({
    url: `/teacher/classes/${data.classId}/requests/review`,
    method: 'post',
    data
  })
}

export function approveAllRequests(data) {
  return request({
    url: `/teacher/classes/${data.classId}/requests/review-all`,
    method: 'post',
    data
  })
}

export function listJoinClassRequests(data) {
  return request({
    url: `/teacher/classes/${data.classId}/requests` + serialize(data),
    method: 'get'
  })
}

export function updateStudentStatus(data) {
  return request({
    url: `/teacher/classes/${data.classId}/students/${data.eID}/status`,
    method: 'put',
    data
  })
}

export function updateClassStatus(data) {
  return request({
    url: `/teacher/classes/${data.classId}/status`,
    method: 'put',
    data
  })
}
